/** Rota `/cadastro/:recurso` — resolve o descriptor e renderiza a lista genérica. */
import { Navigate, useParams } from 'react-router-dom';
import { ListaRecurso } from '@/components/crud/ListaRecurso';
import { obterRecurso } from '@/lib/recursos';

export function RecursoLista() {
  const { recurso } = useParams();
  const descritor = obterRecurso(recurso);
  if (!descritor) return <Navigate to="/cadastro" replace />;
  // `key` força remontar ao trocar de entidade — zera busca/paginação sem estado preso.
  return <ListaRecurso key={descritor.chave} descritor={descritor} />;
}
